import {Base} from '../Base';

export class Randstad extends Base{
    constructor () {
        super();
    }
}

const randstadTheme = new Randstad();
export default randstadTheme;



// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/Randstad/Randstad.ts